import React from 'react'
import { SelectInput } from 'react-admin'

const AppliesToSelect = props => {
  const choices = [
    { id: 'transaction', name: 'Transaction' },
    { id: 'checkout', name: 'Checkout' },
    { id: 'card_validation', name: 'Card Validation' }
  ]

  return (
    <SelectInput {...props} choices={choices}/>
  )
}

export default AppliesToSelect
